import { SET_PERMISSION } from "../actions/types";

const initialPermissions = [];

//Hide and Show toast messages
export const permissionReducer = (state = initialPermissions, { type, payload }) => {
  switch (type) {
    case SET_PERMISSION:
      return [...payload];
    default:
      return state;
  }
};
